<template>
    <div class="sub-assignments">
        <div class="sub-assignment-page" :class="part.type === 1 ? 'sub-assignment-explanation' : 'sub-assignment'"
             v-for="part in selectedPage.parts"
             :key="part.id">
            <design-2021-assignment-show-explanation-part-component
                :part-in="part"
                v-if="part.isExplanation()">
            </design-2021-assignment-show-explanation-part-component>

            <design-2021-assignment-show-assignment-part-component
                :profile-categories-in="profileCategoriesIn"
                :part-in="part"
                :can-answer="canAnswer"
                :is-example-in="isExampleIn"
                :project-id="projectId"
                :is-coop-in="isCoop"
                v-if="part.isAssignment()">
            </design-2021-assignment-show-assignment-part-component>
        </div>

        <div class="sub-assignment-footer">
            <div class="sub-assignment-pagination" v-if="subAssignmentIn.pages.length > 1">
                <div class="apprentice-pagination assignment-paged-pagination">
                    <ul class="pagination b-pagination">
                        <li class="page-item page-navigate-next">
                            <b-button variant="primary-icon"
                                      class="btn-chevron-left btn-previous"
                                      @click="showPrevious"
                                      :disabled="isFirstPage">
                            </b-button>
                        </li>

                        <li class="page-item" :class="page === selectedPage.order && 'active'"
                            v-for="page in subAssignmentIn.pages.length">
                            <b-button variant="primary-icon"
                                      :disabled="(page === 1 && page === selectedPage.order) || (page === selectedPage.order && page === subAssignmentIn.pages.length - 1)"
                                      class="btn-page-index"
                                      @click="showCurrent(page)">
                                {{ page }}
                            </b-button>
                        </li>

                        <li class="page-item page-navigate-previous">
                            <b-button variant="primary-icon"
                                      :disabled="isLastPage"
                                      class="btn-chevron-right btn-next"
                                      @click="showNext">
                            </b-button>
                        </li>
                    </ul>
                </div>
            </div>

            <design-2021-assignment-show-sub-assignment-submit-component
                :assignment-in="assignmentIn"
                v-if="canSubmitAssignment"
                :sub-assignment-in="subAssignmentIn"
                :project-id="projectId"
                :assignment-status-in="assignmentStatusIn"
                type-in="assignment"
                @submitted="submitted('assignment')">
            </design-2021-assignment-show-sub-assignment-submit-component>

            <design-2021-assignment-show-sub-assignment-submit-component
                :assignment-in="assignmentIn"
                v-if="canSubmitExplanation"
                :sub-assignment-in="subAssignmentIn"
                :project-id="projectId"
                :assignment-status-in="assignmentStatusIn"
                type-in="only_explanation"
                @submitted="submitted('only_explanation')">
            </design-2021-assignment-show-sub-assignment-submit-component>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-assignment-show-sub-assignment-paged-view-component",
    props: [
        'assignmentIn',
        'subAssignmentIn',
        'canAnswer',
        'projectId',
        'assignmentStatusIn',
        'selectedPageIdIn',
        'profileCategoriesIn',
        'isExampleIn'
    ],
    computed: {
        isCoop() {
            if (this.assignmentIn.assignment_cooperations.length) {
                return true
            }
            if (this.subAssignmentIn.assignment_cooperations.length) {
                return true
            }
            return false;
        },
        selectedPage() {
            if (!this.subAssignmentIn.pages.length) {
                return null;
            }

            for (const page of this.subAssignmentIn.pages) {
                if (page.id === this.selectedPageIdIn) {
                    return page;
                }
            }

            return this.subAssignmentIn.pages[0];
        },
        isFirstPage() {
            if (!this.subAssignmentIn.pages.length) {
                return false;
            }

            return (this.selectedPageIdIn === this.subAssignmentIn.pages[0].id)
        },
        isLastPage() {
            if (!this.subAssignmentIn.pages.length) {
                return false;
            }

            return (this.selectedPageIdIn === this.subAssignmentIn.pages[this.subAssignmentIn.pages.length - 1].id)
        },
        canSubmitExplanation() {

            if (
                !this.isLastPage ||
                !this.projectId ||
                !this.subAssignmentIn.onlyExplanation() ||
                (this.subAssignmentIn.getStatus() && this.subAssignmentIn.getStatus().isInClosedState())
            ) {
                return false;
            }

            return !this.subAssignmentIn.hasStatus() || this.subAssignmentIn.getStatus().isWaitingForSubmit();
        },
        canSubmitAssignment() {

            if (!this.projectId) {
                return false;
            }

            if (!this.isLastPage) {
                return false;
            }

            if (!this.subAssignmentIn.hasPartWithTypeAssignment()) {
                return false;
            }

            return !this.subAssignmentIn.hasStatus() || this.subAssignmentIn.getStatus().isWaitingForSubmit()
        },
        // canAddToProfile() {
        //     return (this.$authUser.isStudent() || this.$authUser.isAdmin())
        //     && this.selectedContainer.type === 2
        //     && (this.selectedContainer.parts[0].isAssignmentFileUpload() || this.selectedContainer.parts[0].isAssignmentEditor())
        //     && this.selectedContainer.parts[0].hasAnswer()
        //     && this.selectedContainer.parts[0].getAnswer().files.length
        // }
    },
    methods: {
        showPrevious() {
            for (let i = 0; i < this.subAssignmentIn.pages.length; i++) {
                if (this.subAssignmentIn.pages[i].id === this.selectedPageIdIn) {
                    this.$emit('page-changed', this.subAssignmentIn.pages[i - 1].id)
                    this.scrollToTop();
                    return
                }
            }
        },
        showNext() {
            for (let i = 0; i < this.subAssignmentIn.pages.length; i++) {
                if (this.subAssignmentIn.pages[i].id === this.selectedPageIdIn) {
                    this.$emit('page-changed', this.subAssignmentIn.pages[i + 1].id)
                    this.scrollToTop();
                    return
                }
            }
        },
        showCurrent(pageIndex) {
            this.$emit('page-changed', this.subAssignmentIn.pages[pageIndex - 1].id)
            this.scrollToTop();
            return
        },

        submitted() {
            this.$emit('submitted')
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped lang="scss">
.sub-assignments {
    .sub-assignment-page {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .sub-assignment-explanation:not(:last-child),
        .sub-assignment:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.sub-assignments-submit {
    .btn-hand-in-sub-assignment {
        width: 100%
    }
}

.sub-assignment-footer {
    display: flex;
    flex-direction: row;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .sub-assignment-pagination {
        margin-left: calc(50% - 75px);
        align-self: center;
    }
}

.assignment-paged-pagination ::v-deep {
    margin-top: 0;

    .pagination {
        margin-bottom: 0;
    }

    .page-item {
        width: 30px;
        height: 30px;

        &.page-navigate-next,
        &.page-navigate-previous {
            .btn:before {
                font-size: 0.625rem;
            }
        }

        .btn {
            background-color: transparent;
            border: none;
            outline: none;
            box-shadow: none;
            color: $primary;
            font-size: $default-font-size;
            padding: 8px 12px;
            line-height: 1;
            width: 30px;
            height: 30px;

            &:before {
                margin-right: 0;
            }

            &:hover {
                color: $info;
                font-weight: $font-weight-medium;
                background-color: $secondary-background-color;
            }
        }

        &.active {
            .btn {
                color: $white;
                background-color: $primary;
            }
        }
    }
}

</style>
